export const LIBRARY = "library";
export const CREATION = "scenario-creation";

export const REPORTING = "reporting";
export const PRICE_BRACKET = "price-bracket";

export const PRICE_ELASTICITY = "price-elasticity";

export const SWITCHING_MATRIX = "switching-matrix";

export const DASHBOARD = "dashboard";
export const NEW_FEATURE = 'new-feature'
